"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultPDFStyles = {
    patientReportHeader: {
        columnGap: 20,
        margin: [20, 25],
        fontSize: 10,
    },
    patientReportFooter: {
        columnGap: 20,
        margin: [20, 25],
        fontSize: 10,
    },
    patientInfoSection: {
        margin: [20, 10],
    },
    sectionContainer: {},
    defaultTable: {},
    boolean: {},
    number: {},
    markdown: {},
    text: {},
    date: {},
    defaultContentArray: {},
    blockSection: {
        margin: [5, 10],
    },
    documentTitle: {
        alignment: 'center',
        fontSize: 20,
        bold: true,
        margin: [0, 0, 0, 10],
    },
    sectionTitle: {
        alignment: 'left',
        fontSize: 14,
        bold: true,
        margin: [0, 0, 0, 5],
    },
    subsectionTitle: {
        alignment: 'left',
        fontSize: 18,
    },
    subtitle: {
        bold: true,
    },
    endDocument: {
        italics: true,
        alignment: 'center',
    },
    endSection: {
        alignment: 'center',
        margin: [0, 0, 0, 10],
    },
    endSubsection: {
        alignment: 'center',
    },
    link: {
        color: 'blue',
    },
};
exports.default = defaultPDFStyles;
//# sourceMappingURL=styles.js.map